// extracted by mini-css-extract-plugin
export default {"main-container":"_7igPsgrrH3oK50kjY1DrTw==","content":"_8Ysquim51bcLoiiIQDTq1Q==","icon":"rb47wxX+QM--2WfLpH8xnQ==","badge":"RU-fqhAL88NAk13m5var3w=="};